export const GlobeMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <g stroke="var(--teal)" strokeWidth="1.1">
      <circle cx="20" cy="20" r="18.5" />
      <ellipse cx="20" cy="20" rx="8" ry="18.5" />
      <path d="M1.5 20h37" />
      <path d="M4.2 11q15.8 4 31.6 0" />
      <path d="M4.2 29q15.8 -4 31.6 0" />
    </g>
  </svg>
);

export default GlobeMark;
